export const ChatActionTypes = {
  INIT_CHAT_SCREEN: 'INIT_CHAT_SCREEN',
  UPDATE_MESSAGE_LIST: 'UPDATE_MESSAGE_LIST',
  UPDATE_PRAYER_LIST: 'UPDATE_PRAYER_LIST',
  SET_USER_TYPING: 'SET_USER_TYPING',
  UPDATE_OWNER_LIST: 'UPDATE_OWNER_LIST',
  UPDATE_MEMBER_LIST: 'UPDATE_MEMBER_LIST',
  UPDATE_BLOCKED_USER_LIST: 'UPDATE_BLOCKED_USER_LIST',
  UPDATE_INVITED_LIST: 'UPDATE_INVITED_LIST',
  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_BLOCKED_USER: 'SET_BLOCKED_USER',
  SET_UNBLOCKED_USER: 'SET_UNBLOCKED_USER',
  SET_ADDED_USERS: 'SET_ADDED_USERS',
  SET_REMOVED_MEMBER: 'SET_REMOVED_MEMBER',
  SET_CHANNEL: 'SET_CHANNEL',
  SET_CHANNEL_NAME: 'SET_CHANNEL_NAME',
  SET_PARENT_MESSAGE_ID: 'SET_PARENT_MESSAGE_ID',
  SET_SEND_TO_CHANNEL: 'SET_SEND_TO_CHANNEL',
  SET_INVITE_ACCEPTED: 'SET_INVITE_ACCEPTED',
  SET_JOIN_REQUESTS: 'SET_JOIN_REQUESTS',
  REMOVE_JOIN_REQUEST: 'REMOVE_JOIN_REQUEST',
  RESET_CHAT_STATE: 'RESET_CHAT_STATE',
  SET_INITIAL_ATTENDANCE_MEMBER_LIST: 'SET_INITIAL_ATTENDANCE_MEMBER_LIST',
};
